import React from 'react';
import NotFound from '../components/errors/NotFound';
import Error500 from '../components/errors/Error500';

const Error = ({ statusCode }) => {
    if (statusCode === 404) {
        return <NotFound />;
    }
    if (!statusCode || statusCode !== 200) {
        return <Error500 />;
    }
    return <></>;
};

Error.getInitialProps = ({ res, err }) => {
    res.setHeader('x-frame-options','DENY');
    const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
    return { statusCode };
};

export default Error;
